import Script from 'next/script'
import { FC } from 'react'

interface AnalyticsScriptsProps {
  enabled: boolean
}

const AnalyticsScripts: FC<AnalyticsScriptsProps> = ({ enabled }) => {
  if (!enabled) {
    return null
  }

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=GTM-MLR6F82X"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-RE7QW8JV1G');
        `}
      </Script>
    </>
  )
}

export default AnalyticsScripts
